/* Generated from Aurora Beautiful product photos matched by Aurora ID. Do not edit by hand. */
export const importedProductImages: Record<string, string[]> = {
  "324": [
    "/assets/images/products/324/01.webp"
  ],
  "327": [
    "/assets/images/products/327/01.webp"
  ],
  "330": [
    "/assets/images/products/330/01.webp"
  ],
  "333": [
    "/assets/images/products/333/01.webp"
  ],
  "336": [
    "/assets/images/products/336/01.webp"
  ],
  "339": [
    "/assets/images/products/339/01.webp"
  ],
  "342": [
    "/assets/images/products/342/01.webp"
  ],
  "345": [
    "/assets/images/products/345/01.webp"
  ],
  "348": [
    "/assets/images/products/348/01.webp"
  ],
  "351": [
    "/assets/images/products/351/01.webp"
  ],
  "354": [
    "/assets/images/products/354/01.webp"
  ],
  "357": [
    "/assets/images/products/357/01.webp"
  ],
  "360": [
    "/assets/images/products/360/01.webp"
  ],
  "363": [
    "/assets/images/products/363/01.webp"
  ],
  "369": [
    "/assets/images/products/369/01.webp"
  ],
  "375": [
    "/assets/images/products/375/01.webp"
  ],
  "385": [
    "/assets/images/products/385/01.webp"
  ],
  "388": [
    "/assets/images/products/388/01.webp"
  ],
  "392": [
    "/assets/images/products/392/01.webp"
  ],
  "395": [
    "/assets/images/products/395/01.webp"
  ],
  "398": [
    "/assets/images/products/398/01.webp"
  ],
  "401": [
    "/assets/images/products/401/01.webp"
  ],
  "404": [
    "/assets/images/products/404/01.webp"
  ],
  "418": [
    "/assets/images/products/418/01.webp"
  ],
  "421": [
    "/assets/images/products/421/01.webp"
  ],
  "427": [
    "/assets/images/products/427/01.webp"
  ],
  "430": [
    "/assets/images/products/430/01.webp"
  ],
  "436": [
    "/assets/images/products/436/01.webp"
  ],
  "439": [
    "/assets/images/products/439/01.webp"
  ],
  "442": [
    "/assets/images/products/442/01.webp"
  ],
  "445": [
    "/assets/images/products/445/01.webp"
  ],
  "451": [
    "/assets/images/products/451/01.webp"
  ],
  "457": [
    "/assets/images/products/457/01.webp"
  ],
  "463": [
    "/assets/images/products/463/01.webp"
  ],
  "475": [
    "/assets/images/products/475/01.webp"
  ],
  "487": [
    "/assets/images/products/487/01.webp"
  ],
  "490": [
    "/assets/images/products/490/01.webp"
  ],
  "493": [
    "/assets/images/products/493/01.webp"
  ],
  "496": [
    "/assets/images/products/496/01.webp"
  ],
  "499": [
    "/assets/images/products/499/01.webp"
  ],
  "502": [
    "/assets/images/products/502/01.webp"
  ],
  "507": [
    "/assets/images/products/507/01.webp"
  ],
  "510": [
    "/assets/images/products/510/01.webp"
  ],
  "513": [
    "/assets/images/products/513/01.webp"
  ],
  "516": [
    "/assets/images/products/516/01.webp"
  ],
  "519": [
    "/assets/images/products/519/01.webp"
  ],
  "522": [
    "/assets/images/products/522/01.webp"
  ],
  "525": [
    "/assets/images/products/525/01.webp"
  ],
  "528": [
    "/assets/images/products/528/01.webp"
  ],
  "531": [
    "/assets/images/products/531/01.webp"
  ],
  "534": [
    "/assets/images/products/534/01.webp"
  ],
  "537": [
    "/assets/images/products/537/01.webp"
  ],
  "540": [
    "/assets/images/products/540/01.webp"
  ],
  "543": [
    "/assets/images/products/543/01.webp"
  ],
  "546": [
    "/assets/images/products/546/01.webp"
  ],
  "549": [
    "/assets/images/products/549/01.webp"
  ],
  "555": [
    "/assets/images/products/555/01.webp"
  ],
  "558": [
    "/assets/images/products/558/01.webp"
  ],
  "561": [
    "/assets/images/products/561/01.webp"
  ],
  "564": [
    "/assets/images/products/564/01.webp"
  ],
  "567": [
    "/assets/images/products/567/01.webp"
  ],
  "570": [
    "/assets/images/products/570/01.webp"
  ],
  "574": [
    "/assets/images/products/574/01.webp"
  ],
  "577": [
    "/assets/images/products/577/01.webp"
  ],
  "586": [
    "/assets/images/products/586/01.webp"
  ],
  "589": [
    "/assets/images/products/589/01.webp"
  ],
  "592": [
    "/assets/images/products/592/01.webp"
  ],
  "595": [
    "/assets/images/products/595/01.webp"
  ],
  "599": [
    "/assets/images/products/599/01.webp"
  ],
  "602": [
    "/assets/images/products/602/01.webp"
  ],
  "605": [
    "/assets/images/products/605/01.webp"
  ],
  "608": [
    "/assets/images/products/608/01.webp"
  ],
  "614": [
    "/assets/images/products/614/01.webp"
  ],
  "617": [
    "/assets/images/products/617/01.webp"
  ],
  "620": [
    "/assets/images/products/620/01.webp"
  ],
  "623": [
    "/assets/images/products/623/01.webp"
  ],
  "626": [
    "/assets/images/products/626/01.webp"
  ],
  "630": [
    "/assets/images/products/630/01.webp"
  ],
  "636": [
    "/assets/images/products/636/01.webp"
  ],
  "639": [
    "/assets/images/products/639/01.webp"
  ],
  "642": [
    "/assets/images/products/642/01.webp"
  ],
  "645": [
    "/assets/images/products/645/01.webp"
  ],
  "648": [
    "/assets/images/products/648/01.webp"
  ],
  "654": [
    "/assets/images/products/654/01.webp"
  ],
  "657": [
    "/assets/images/products/657/01.webp"
  ],
  "660": [
    "/assets/images/products/660/01.webp"
  ],
  "663": [
    "/assets/images/products/663/01.webp"
  ],
  "666": [
    "/assets/images/products/666/01.webp"
  ],
  "669": [
    "/assets/images/products/669/01.webp"
  ],
  "673": [
    "/assets/images/products/673/01.webp"
  ],
  "679": [
    "/assets/images/products/679/01.webp"
  ],
  "682": [
    "/assets/images/products/682/01.webp"
  ],
  "687": [
    "/assets/images/products/687/01.webp"
  ],
  "690": [
    "/assets/images/products/690/01.webp"
  ],
  "694": [
    "/assets/images/products/694/01.webp"
  ],
  "697": [
    "/assets/images/products/697/01.webp"
  ],
  "700": [
    "/assets/images/products/700/01.webp"
  ],
  "703": [
    "/assets/images/products/703/01.webp"
  ],
  "706": [
    "/assets/images/products/706/01.webp"
  ],
  "709": [
    "/assets/images/products/709/01.webp"
  ],
  "712": [
    "/assets/images/products/712/01.webp"
  ],
  "715": [
    "/assets/images/products/715/01.webp"
  ],
  "718": [
    "/assets/images/products/718/01.webp"
  ],
  "721": [
    "/assets/images/products/721/01.webp"
  ],
  "724": [
    "/assets/images/products/724/01.webp"
  ],
  "727": [
    "/assets/images/products/727/01.webp"
  ],
  "730": [
    "/assets/images/products/730/01.webp"
  ],
  "733": [
    "/assets/images/products/733/01.webp"
  ],
  "736": [
    "/assets/images/products/736/01.webp"
  ],
  "742": [
    "/assets/images/products/742/01.webp"
  ],
  "745": [
    "/assets/images/products/745/01.webp"
  ],
  "748": [
    "/assets/images/products/748/01.webp"
  ],
  "751": [
    "/assets/images/products/751/01.webp"
  ],
  "754": [
    "/assets/images/products/754/01.webp"
  ],
  "757": [
    "/assets/images/products/757/01.webp"
  ],
  "760": [
    "/assets/images/products/760/01.webp"
  ],
  "763": [
    "/assets/images/products/763/01.webp"
  ],
  "766": [
    "/assets/images/products/766/01.webp"
  ],
  "769": [
    "/assets/images/products/769/01.webp"
  ],
  "772": [
    "/assets/images/products/772/01.webp"
  ],
  "775": [
    "/assets/images/products/775/01.webp"
  ],
  "778": [
    "/assets/images/products/778/01.webp"
  ],
  "781": [
    "/assets/images/products/781/01.webp"
  ],
  "784": [
    "/assets/images/products/784/01.webp"
  ],
  "787": [
    "/assets/images/products/787/01.webp"
  ],
  "790": [
    "/assets/images/products/790/01.webp"
  ],
  "793": [
    "/assets/images/products/793/01.webp"
  ],
  "796": [
    "/assets/images/products/796/01.webp"
  ],
  "801": [
    "/assets/images/products/801/01.webp"
  ],
  "812": [
    "/assets/images/products/812/01.webp"
  ],
  "816": [
    "/assets/images/products/816/01.webp"
  ],
  "824": [
    "/assets/images/products/824/01.webp"
  ],
  "827": [
    "/assets/images/products/827/01.webp"
  ],
  "830": [
    "/assets/images/products/830/01.webp"
  ],
  "835": [
    "/assets/images/products/835/01.webp"
  ],
  "838": [
    "/assets/images/products/838/01.webp"
  ],
  "841": [
    "/assets/images/products/841/01.webp"
  ],
  "844": [
    "/assets/images/products/844/01.webp"
  ],
  "850": [
    "/assets/images/products/850/01.webp"
  ],
  "855": [
    "/assets/images/products/855/01.webp"
  ],
  "858": [
    "/assets/images/products/858/01.webp"
  ],
  "863": [
    "/assets/images/products/863/01.webp"
  ],
  "866": [
    "/assets/images/products/866/01.webp"
  ],
  "877": [
    "/assets/images/products/877/01.webp"
  ],
  "882": [
    "/assets/images/products/882/01.webp"
  ],
  "887": [
    "/assets/images/products/887/01.webp"
  ],
  "890": [
    "/assets/images/products/890/01.webp"
  ],
  "893": [
    "/assets/images/products/893/01.webp"
  ],
  "897": [
    "/assets/images/products/897/01.webp"
  ],
  "902": [
    "/assets/images/products/902/01.webp"
  ],
  "905": [
    "/assets/images/products/905/01.webp"
  ],
  "908": [
    "/assets/images/products/908/01.webp"
  ],
  "930": [
    "/assets/images/products/930/01.webp"
  ],
  "935": [
    "/assets/images/products/935/01.webp"
  ],
  "938": [
    "/assets/images/products/938/01.webp"
  ],
  "941": [
    "/assets/images/products/941/01.webp"
  ],
  "944": [
    "/assets/images/products/944/01.webp"
  ],
  "947": [
    "/assets/images/products/947/01.webp"
  ],
  "952": [
    "/assets/images/products/952/01.webp"
  ],
  "955": [
    "/assets/images/products/955/01.webp"
  ],
  "958": [
    "/assets/images/products/958/01.webp"
  ],
  "961": [
    "/assets/images/products/961/01.webp"
  ],
  "966": [
    "/assets/images/products/966/01.webp"
  ],
  "969": [
    "/assets/images/products/969/01.webp"
  ],
  "972": [
    "/assets/images/products/972/01.webp"
  ],
  "975": [
    "/assets/images/products/975/01.webp"
  ],
  "978": [
    "/assets/images/products/978/01.webp"
  ],
  "983": [
    "/assets/images/products/983/01.webp"
  ],
  "986": [
    "/assets/images/products/986/01.webp"
  ],
  "991": [
    "/assets/images/products/991/01.webp"
  ],
  "995": [
    "/assets/images/products/995/01.webp"
  ],
  "998": [
    "/assets/images/products/998/01.webp"
  ],
  "1001": [
    "/assets/images/products/1001/01.webp"
  ],
  "1004": [
    "/assets/images/products/1004/01.webp"
  ],
  "1007": [
    "/assets/images/products/1007/01.webp"
  ],
  "1010": [
    "/assets/images/products/1010/01.webp"
  ],
  "1016": [
    "/assets/images/products/1016/01.webp"
  ],
  "1019": [
    "/assets/images/products/1019/01.webp"
  ],
  "1022": [
    "/assets/images/products/1022/01.webp"
  ],
  "1025": [
    "/assets/images/products/1025/01.webp"
  ],
  "1028": [
    "/assets/images/products/1028/01.webp"
  ],
  "1031": [
    "/assets/images/products/1031/01.webp"
  ],
  "1034": [
    "/assets/images/products/1034/01.webp"
  ],
  "1037": [
    "/assets/images/products/1037/01.webp"
  ],
  "1042": [
    "/assets/images/products/1042/01.webp"
  ],
  "1045": [
    "/assets/images/products/1045/01.webp"
  ],
  "1048": [
    "/assets/images/products/1048/01.webp"
  ],
  "1051": [
    "/assets/images/products/1051/01.webp"
  ],
  "1056": [
    "/assets/images/products/1056/01.webp"
  ],
  "1059": [
    "/assets/images/products/1059/01.webp"
  ],
  "1062": [
    "/assets/images/products/1062/01.webp"
  ],
  "1064": [
    "/assets/images/products/1064/01.webp"
  ],
  "1069": [
    "/assets/images/products/1069/01.webp"
  ],
  "1073": [
    "/assets/images/products/1073/01.webp"
  ],
  "1076": [
    "/assets/images/products/1076/01.webp"
  ],
  "1079": [
    "/assets/images/products/1079/01.webp"
  ],
  "1084": [
    "/assets/images/products/1084/01.webp"
  ],
  "1093": [
    "/assets/images/products/1093/01.webp"
  ],
  "1096": [
    "/assets/images/products/1096/01.webp"
  ],
  "1099": [
    "/assets/images/products/1099/01.webp"
  ],
  "1102": [
    "/assets/images/products/1102/01.webp"
  ],
  "1105": [
    "/assets/images/products/1105/01.webp"
  ],
  "1108": [
    "/assets/images/products/1108/01.webp"
  ],
  "1113": [
    "/assets/images/products/1113/01.webp"
  ],
  "1117": [
    "/assets/images/products/1117/01.webp"
  ],
  "1120": [
    "/assets/images/products/1120/01.webp"
  ],
  "1123": [
    "/assets/images/products/1123/01.webp"
  ],
  "1129": [
    "/assets/images/products/1129/01.webp"
  ],
  "1132": [
    "/assets/images/products/1132/01.webp"
  ],
  "1135": [
    "/assets/images/products/1135/01.webp"
  ],
  "1138": [
    "/assets/images/products/1138/01.webp"
  ],
  "1141": [
    "/assets/images/products/1141/01.webp"
  ],
  "1144": [
    "/assets/images/products/1144/01.webp"
  ],
  "1147": [
    "/assets/images/products/1147/01.webp"
  ],
  "1150": [
    "/assets/images/products/1150/01.webp"
  ],
  "1153": [
    "/assets/images/products/1153/01.webp"
  ],
  "1156": [
    "/assets/images/products/1156/01.webp"
  ],
  "1159": [
    "/assets/images/products/1159/01.webp"
  ],
  "1162": [
    "/assets/images/products/1162/01.webp"
  ],
  "1165": [
    "/assets/images/products/1165/01.webp"
  ],
  "1169": [
    "/assets/images/products/1169/01.webp"
  ],
  "1172": [
    "/assets/images/products/1172/01.webp"
  ],
  "1175": [
    "/assets/images/products/1175/01.webp"
  ],
  "1178": [
    "/assets/images/products/1178/01.webp"
  ],
  "1181": [
    "/assets/images/products/1181/01.webp"
  ],
  "1184": [
    "/assets/images/products/1184/01.webp"
  ],
  "1187": [
    "/assets/images/products/1187/01.webp"
  ],
  "1190": [
    "/assets/images/products/1190/01.webp"
  ],
  "1193": [
    "/assets/images/products/1193/01.webp"
  ],
  "1196": [
    "/assets/images/products/1196/01.webp"
  ],
  "1199": [
    "/assets/images/products/1199/01.webp"
  ],
  "1202": [
    "/assets/images/products/1202/01.webp"
  ],
  "1205": [
    "/assets/images/products/1205/01.webp"
  ],
  "1208": [
    "/assets/images/products/1208/01.webp"
  ],
  "1211": [
    "/assets/images/products/1211/01.webp"
  ],
  "1214": [
    "/assets/images/products/1214/01.webp"
  ],
  "1217": [
    "/assets/images/products/1217/01.webp"
  ],
  "1220": [
    "/assets/images/products/1220/01.webp"
  ],
  "1223": [
    "/assets/images/products/1223/01.webp"
  ],
  "1226": [
    "/assets/images/products/1226/01.webp"
  ],
  "1229": [
    "/assets/images/products/1229/01.webp"
  ],
  "1232": [
    "/assets/images/products/1232/01.webp"
  ],
  "1251": [
    "/assets/images/products/1251/01.webp"
  ],
  "1254": [
    "/assets/images/products/1254/01.webp"
  ],
  "1257": [
    "/assets/images/products/1257/01.webp"
  ],
  "1260": [
    "/assets/images/products/1260/01.webp"
  ],
  "1263": [
    "/assets/images/products/1263/01.webp"
  ],
  "1266": [
    "/assets/images/products/1266/01.webp"
  ],
  "1269": [
    "/assets/images/products/1269/01.webp"
  ],
  "1272": [
    "/assets/images/products/1272/01.webp"
  ]
};
